import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { EmailConfirmation } from './email-confirmation';
import { StoreAppointments } from './store-appointments';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SignupServiceService {

  constructor(private http: HttpClient) { }

  emailConfirmation(data:string): Observable<EmailConfirmation> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    
    return this.http.post<EmailConfirmation>('/api/storeAppointment', data, {headers: baseHeaders})
    .pipe(map( response => {
        console.log("Hi, I sent the email!")
        return response
      }))
  }
    
  
  storeAppointments(data: string): Observable<StoreAppointments> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<StoreAppointments>('/api/storeAppointment', data, {headers: baseHeaders})
      .pipe(take(1))
  }
}
